var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormularioDinamico',{attrs:{"id-formulario":_vm.nIdFormulario,"show-buttons":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }